import { FC, ReactNode, useMemo } from 'react';
import { CustomViewPageMeta, CustomViewPages } from './pages';
import { extractIncludeFromCode } from './utils';
import { dumpJsxAsYaml } from './jsxSerializer';

type CustomViewPageMetadataType = {
  included: any[];
  getCodeAsYaml: () => string;
  pageId: string;
  meta: CustomViewPageMeta;
};

export const CustomViewPageMetadata: FC<{
  pageId: string;
  children: (metadata: CustomViewPageMetadataType) => ReactNode;
}> = ({ pageId, children }) => {
  const meta = CustomViewPages.getMetadata(pageId);
  const defaultView = CustomViewPages.get(pageId);

  if (!meta || !defaultView)
    throw new Error(`Could not find custom view with id ${pageId}`);

  const included = extractIncludeFromCode(defaultView, '', '');

  const enrichedMetadata = useMemo(
    () => ({
      included,
      getCodeAsYaml: () => dumpJsxAsYaml(defaultView),
      pageId: pageId,
      meta,
    }),
    [defaultView, included, pageId, meta],
  );

  return children(enrichedMetadata);
};
